import React from "react";
import { useMediaQuery } from "../../common/hooks/use-media-query";

function Services() {
  const isRow = useMediaQuery("(min-width: 1000px)");

  return (
    <section id="services" className="tc-services-style1">
      <div className="content section-padding section-padding-x">
        <div className="container">
          <div className="title mb-80 text-center">
            <p className="color-666 text-uppercase wow"> خدماتنا </p>
          </div>
          <div className="services">
            <div className="row">
              <div className="col-lg-3">
                <a
                  href="#"
                  className="service-card wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="icon">
                    <i className="la la-hard-hat"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">
                    {" "}
                    خدماتنا المعمارية والبنائية{" "}
                  </h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser1.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    في تعمير، نقدم خدمات شاملة تشمل التخطيط، الرسومات ثلاثية
                    الأبعاد، تصميم المساحات الخضراء، الرسم الإنشائي، والإشراف
                    على البناء والتشطيبات. كل مشروع ننفذه يعكس التزامنا بالدقة
                    والجودة، مع ضمان أن تتماشى جميع التفاصيل مع رؤية العميل
                    واحتياجاته، مع الالتزام بالميزانية المحددة لكل مشروع.
                  </div>
                  {/* <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span> */}
                </a>
              </div>
              <div className="col-lg-3">
                <a
                  href="#"
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay={isRow ? "0.4s" : "0.2s"}
                >
                  <div className="icon">
                    <i className="la la-bezier-curve"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">التصميم الداخلي والخارجي</h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser2.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    نهتم في تعمير بتصميم مساحات داخلية وخارجية تجمع بين الأناقة
                    والعملية. هدفنا هو أن تعكس المساحات التي نصممها ذوق عملائنا
                    وتلبي احتياجاتهم اليومية. سواء كنت تبحث عن تجديد أو تشطيب أو
                    إنشاءات جديدة، نقدم تجربة تصميم ثلاثية الأبعاد تتيح لك رؤية
                    الشكل النهائي لمشروعك قبل التنفيذ، مع اهتمامنا بأدق التفاصيل
                    لضمان رضاك التام.
                  </div>
                  {/* <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span> */}
                </a>
              </div>
              <div className="col-lg-3">
                <a
                  href="#"
                  className="service-card wow fadeInUp"
                  data-wow-delay={isRow ? "0.6s" : "0.2s"}
                >
                  <div className="icon">
                    <i className="la la-bed"></i>
                  </div>
                  <h5 className="fsz-24 mb-20"> إنتاج الأثاث</h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser3.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    يختص قسم إنتاج الأثاث في تعمير بصناعة قطع تجمع بين الأناقة،
                    المتانة، والابتكار. سواء كنت بحاجة إلى تصميمات عصرية
                    للمساحات السكنية أو الإدارية، نوفر لك حلول أثاث متميزة
                    تتماشى مع احتياجاتك، باستخدام تقنية ثلاثية الأبعاد لضمان دقة
                    التصميم والتنفيذ.
                  </div>
                  {/* <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span> */}
                </a>
              </div>
              <div className="col-lg-3">
                <a
                  href="#"
                  className="service-card mt-150 wow fadeInUp"
                  data-wow-delay={isRow ? "0.8s" : "0.2s"}
                >
                  <div className="icon">
                    <i className="la la-comments"></i>
                  </div>
                  <h5 className="fsz-24 mb-20">
                    الاستشارات والإشراف على المشاريع
                  </h5>
                  <div className="img">
                    <img
                      src="/home1/assets/img/services/ser4.webp"
                      alt=""
                      className="img-cover"
                    />
                  </div>
                  <div className="text color-666 mt-50">
                    نوجه مشاريعنا من الفكرة إلى التنفيذ النهائي من خلال خدمات
                    الاستشارات الهندسية والإشراف المتكامل. نبدأ بمسح ميداني دقيق
                    وجمع كافة المعلومات والتفاصيل الخاصة بكل مشروع. نقدم تصميمًا
                    أوليًا يشمل الرسومات الفنية، التصورات ثلاثية الأبعاد، وتجربة
                    الواقع الافتراضي لمساعدة العملاء على تصور مشروعهم بدقة. خلال
                    التنفيذ، نهتم بجميع المراحل لضمان الجودة والالتزام بالجداول
                    الزمنية، مع الحفاظ على تواصل مستمر مع العملاء لتلبية
                    تطلعاتهم بدقة.{" "}
                  </div>
                  {/* <span className="arrow">
                    <i className="ti-arrow-top-right"></i>
                  </span> */}
                </a>
              </div>
            </div>
          </div>
          {/* <div className="text-center">
            <a
              href="#"
              className="butn rounded-pill mt-80 hover-bg-black bg-orange1 text-white"
            >
              <span>
                احصل على عرض أسعار الآن
                <i className="small ms-1 ti-arrow-top-right"></i>
              </span>
            </a>
          </div> */}
        </div>
      </div>
      <div className="ser-img">
        <img src="/home1/assets/img/services/ser.webp" alt="" />
      </div>
    </section>
  );
}

export default Services;
